/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:00bde367-acd6-4f28-ac35-2e071bda74d5",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_YImEbx0ym",
    "aws_user_pools_web_client_id": "1suvtjfru2vbbd7185afie2rkp",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://ehqnk4gdk5bhddqhe53ig35wjq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-cwdjdrwfsrhcne4lauw7fwh7m4",
    "aws_user_files_s3_bucket": "homebodyprods3bucket110750-production",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
